export const STATUS_DEFAULT = 'На работе';

const toMillis = (v) => {
  if (!v) return 0;
  if (typeof v === 'number') return v;
  if (typeof v === 'object' && v.toMillis) return v.toMillis();
  return new Date(v).getTime() || 0;
};

export const getEffectiveStatus = (user, now = new Date()) => {
  if (!user?.status) return STATUS_DEFAULT;
  const until = toMillis(user.statusUntil);
  if (until && until < now.getTime()) return STATUS_DEFAULT;
  return user.status;
};

export const isAway = (user, now = new Date()) => getEffectiveStatus(user, now) !== STATUS_DEFAULT;

export const statusWithDays = (user, now = new Date()) => {
  const s = getEffectiveStatus(user, now);
  const until = toMillis(user?.statusUntil);
  if (until && until > now.getTime()) {
    const days = Math.ceil((until - now.getTime()) / 86400000);
    return `${s} [${days} дн.]`;
  }
  return s;
};

export const awayAvatarStyle = (user, now = new Date()) =>
  isAway(user, now)
    ? { opacity: 0.45, filter: 'grayscale(60%)', transition: 'opacity 0.3s' }
    : {};